import "./Icon.scss";

import { CSSProperties, FC, MouseEvent } from "react";

import { ClassName, OrString } from "config/types";
import Svg from "utils/Svg/Svg";

import classNames from "classnames";
import { get, isEmpty, mapKeys, toLower } from "lodash-es";

import icons from "./icons";

type IconSize = "xs" | "sm" | "md" | "lg" | "xl";
export type IconColor =
  | "primary-dark"
  | "cta"
  | "error-dark"
  | "primary-light"
  | "secondary-light"
  | "secondary-text"
  | "success-dark";

interface IProps {
  src: OrString;
  className?: ClassName;
  color?: IconColor;
  dataTestId?: string;
  size?: IconSize;
  style?: CSSProperties;
  svgStyle?: CSSProperties;
  width?: string | number;
  onClick?(event: MouseEvent): void;
}

const Icon: FC<IProps> = props => {
  const { className, color, dataTestId, onClick, size, style, src, svgStyle } = props;
  const classes = classNames(className, "icon-container", {
    [`${size}-size`]: size,
    [`fill-${color}!`]: color,
  });
  const iconName = toLower(src);
  const iconsWithLoweredKeys = mapKeys(icons, (_, key) => toLower(key));

  const iconSrc = get(iconsWithLoweredKeys, iconName, src);
  return isEmpty(iconSrc) ? null : (
    <div
      onClick={(event: MouseEvent) => onClick && onClick(event)}
      className={classes}
      style={style}
      data-testid={dataTestId}>
      <div className="icon-wrapper">
        <Svg className="icon-content" src={iconSrc} svgStyle={svgStyle} />
      </div>
    </div>
  );
};

export default Icon;
